/**
 * Feature flag and defaults for the Blacka customer chatbot.
 */

function normalizeEnvValue(value: string | undefined): string | undefined {
  if (value === undefined) return undefined;
  const trimmed = value.replace(/\r\n/g, '').replace(/\r/g, '').trim();
  return trimmed === '' ? undefined : trimmed;
}

function parseBool(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined || value === '') return defaultValue;
  const normalized = value.trim().toLowerCase();
  if (['true', '1', 'yes', 'y', 'on', 'enabled'].includes(normalized)) return true;
  if (['false', '0', 'no', 'n', 'off', 'disabled'].includes(normalized)) return false;
  return defaultValue;
}

/** Show the Blacka chat widget on the site. */
export const BLACKA_CHAT_ENABLED = parseBool(
  normalizeEnvValue(process.env.REACT_APP_ENABLE_BLACKA_CHATBOT),
  false
);

export const BLACKA_CHAT_FUNCTION = 'blackaChat';

export const BLACKA_GREETING =
  'Wah gwaan! Mi name Blacka — yuh Pack My Cart shopping helper. Mi can help yuh find products, supermarkets, checkout, delivery, an’ more. Wha yuh need?';

export const BLACKA_SITE_URL =
  process.env.REACT_APP_SITE_URL?.trim() ||
  (typeof window !== 'undefined' ? window.location.origin : '');
